window.addEventListener("DOMContentLoaded", function() {
  /* === CODE FOR FAQ ANCHOR LINKS === */
  // Function to close all panels
  function closeAllPanels() {
    var accPanel = document.getElementsByClassName("accordion-panel");
    var accButton = document.getElementsByClassName("accordionHK");

    for (var i = 0; i < accButton.length; i++) {
      accButton[i].classList.remove("active");
    }

    for (var j = 0; j < accPanel.length; j++) {
      accPanel[j].style.maxHeight = null;
    }
  }

  // Function to open the panel based on URL hash
  function openPanelFromHash() {
    var hash = window.location.hash.substr(1); // Get the hash without the '#' symbol

    if (hash) {
      var panelToOpen = document.getElementById(hash); // Find the panel by ID

      if (panelToOpen) {
        // Close all panels first
        closeAllPanels();

        // Open the panel if found
        panelToOpen.style.maxHeight = panelToOpen.scrollHeight + "px";
        panelToOpen.previousElementSibling.classList.add("active");

        // Calculate the offset based on the sticky header height
        var offset = 145; // Adjust this value as needed

        // Scroll to the top of the button using scrollIntoView
        panelToOpen.previousElementSibling.scrollIntoView({
          behavior: "smooth", // Use smooth scrolling animation
          block: "start", // Scroll to the top of the element
        });

        // Listen for the 'scroll' event to ensure the scrolling is complete
        var scrollInterval = setInterval(function () {
          var topPosition = panelToOpen.previousElementSibling.getBoundingClientRect().top;
          if (topPosition <= offset) {
            // Stop the interval
            clearInterval(scrollInterval);

            // Calculate the target position for scrolling and scroll again
            var targetPosition = panelToOpen.previousElementSibling.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
              top: targetPosition,
              behavior: "smooth", // Use smooth scrolling animation
            });
          }
        }, 300); // Adjust the interval duration as needed
      }
    }
  }

  // Handle hash changes
  window.addEventListener("hashchange", openPanelFromHash);
  
  // Run the openPanelFromHash function when the page loads
  openPanelFromHash();

  var acc = document.getElementsByClassName("accordionHK");
  var accPanel = document.getElementsByClassName("accordion-panel");

  // Function to set max-height to 100% and adjust when content changes
  function adjustPanelHeight(panel) {
    panel.style.maxHeight = panel.scrollHeight + "px";

    var observer = new MutationObserver(function() {
      panel.style.maxHeight = "none"; // Temporarily reset max height to calculate content height
      var panelHeight = panel.scrollHeight + "px";
      panel.style.maxHeight = panelHeight;
    });

    // Observe changes in the content of the panel
    observer.observe(panel, { childList: true, subtree: true });

    // Cleanup observer when panel is closed
    panel.addEventListener("transitionend", function() {
      if (!panel.style.maxHeight) {
        observer.disconnect();
      }
    });
  }

  for (var i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      var panel = this.nextElementSibling;

      if (!panel.style.maxHeight) {
        // Close all other panels and remove active class
        for (var j = 0; j < accPanel.length; j++) {
          if (accPanel[j] !== panel) {
            accPanel[j].style.maxHeight = null;
            acc[j].classList.remove("active");
          }
        }

        // Open the panel with an animation and adjust height
        adjustPanelHeight(panel);
        this.classList.add("active");
      } else {
        // Close the panel
        panel.style.maxHeight = null;
        this.classList.remove("active");
      }
    };
  }
});
